<template>
    <div
        class="flex flex-col justify-center items-center"
        :class="{ 'rtl': isRTLMode }"
    >
        <div class="robot-loader">
            <svg
                class="logo"
                xmlns="http://www.w3.org/2000/svg"
                width="100"
                height="100"
                fill="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    d="M12 8V4H8M2 14H4M20 14H22M15 13V15M9 13V15M6 8H18C19.1046 8 20 8.89543 20 10V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V10C4 8.89543 4.89543 8 6 8Z"
                    stroke="currentColor"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="robot-path"
                />
            </svg>
        </div>
        <div
            class="bar-loader flex gap-1"
            :class="{ 'flex-row-reverse': isRTLMode }"
        >
            <div
                v-for="i in 12"
                :key="i"
                class="bars"
                :style="{ animationDelay: `${isRTLMode ? '-' + 0.1 * (i-1) : '-' + 0.1 * (12-i)}s` }"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { isRTL } from '@/composables/useDirection'

const isRTLMode = computed(() => isRTL.value)
</script>

<style scoped lang="scss">
.robot-loader {
    overflow: visible;
    height: fit-content;
    width: fit-content;
    padding: 2px;
    display: flex;
    color: color-mix(in srgb, var(--primary-actions) 30%, transparent);
}

.logo {
    fill: none;
    width: 100%;
    height: 100%;
    stroke-dasharray: 26px;
    animation: load 15s infinite linear;
}

.rtl .logo {
    animation: load-rtl 15s infinite linear;
}

@keyframes load {
    0% { stroke-dashoffset: 250px; }
    100% { stroke-dashoffset: 0; }
}

@keyframes load-rtl {
    0% { stroke-dashoffset: 0; }
    100% { stroke-dashoffset: 250px; }
}

.bar-loader {
    display: flex;
}

.bars {
    width: 3px;
    height: 16px;
    border-radius: 4px;
    background-color: color-mix(in srgb, var(--primary-actions) 30%, transparent);
    animation: loader3 1.5s ease-in-out infinite;
}

@keyframes loader3 {
    0% { transform: scale(1); }
    20% { transform: scale(1, 1.5); }
    40% { transform: scale(1); }
}
</style>
